<template>
    <div v-if="!hasAccess" class="relative min-h-[calc(100vh-65px)]">
        <!-- Renderiza o componente real com blur -->
        <div class="pointer-events-none select-none" style="filter: blur(3px); opacity: 0.5;">
            <slot />
        </div>

        <!-- Overlay com CTA -->
        <div class="absolute inset-0 z-40 flex items-start justify-center pt-[15vh]">
            <div class="bg-white rounded-2xl shadow-2xl border border-gray-200 max-w-md w-full mx-4 p-8 text-center">
                <div class="mx-auto w-16 h-16 bg-gradient-to-br from-gray-800 to-gray-600 rounded-2xl flex items-center justify-center mb-5">
                    <svg class="w-8 h-8 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5"
                            d="M9.813 15.904L9 18.75l-.813-2.846a4.5 4.5 0 00-3.09-3.09L2.25 12l2.846-.813a4.5 4.5 0 003.09-3.09L9 5.25l.813 2.846a4.5 4.5 0 003.09 3.09L15.75 12l-2.846.813a4.5 4.5 0 00-3.09 3.09zM18.259 8.715L18 9.75l-.259-1.035a3.375 3.375 0 00-2.455-2.456L14.25 6l1.036-.259a3.375 3.375 0 002.455-2.456L18 2.25l.259 1.035a3.375 3.375 0 002.455 2.456L21.75 6l-1.036.259a3.375 3.375 0 00-2.455 2.456zM16.894 20.567L16.5 21.75l-.394-1.183a2.25 2.25 0 00-1.423-1.423L13.5 18.75l1.183-.394a2.25 2.25 0 001.423-1.423l.394-1.183.394 1.183a2.25 2.25 0 001.423 1.423l1.183.394-1.183.394a2.25 2.25 0 00-1.423 1.423z" />
                    </svg>
                </div>

                <h2 class="text-xl font-bold text-gray-900 mb-2">{{ title }}</h2>

                <p class="text-gray-500 text-sm mb-6 leading-relaxed">
                    {{ description }}
                </p>

                <div v-if="currentPlanName" class="inline-flex items-center gap-2 bg-gray-100 rounded-full px-4 py-1.5 mb-6">
                    <span class="text-xs text-gray-500">Seu plano:</span>
                    <span class="text-xs font-semibold text-gray-700">{{ currentPlanName }}</span>
                </div>

                <div>
                    <button @click="contactSupport"
                        class="w-full bg-gray-900 hover:bg-gray-800 text-white font-medium py-3 px-6 rounded-xl transition-colors duration-200 text-sm">
                        Falar com o suporte
                    </button>
                    <a href="https://sistema.sistemawbuy.com.br/painel/" target="_blank"
                        class="w-full mt-2 bg-white hover:bg-gray-50 text-gray-700 font-medium py-3 px-6 rounded-xl transition-colors duration-200 text-sm border border-gray-300 block text-center">
                        Acessar painel wBuy
                    </a>
                    <button @click="goBack"
                        class="w-full mt-2 text-gray-400 hover:text-gray-600 font-medium py-2 px-6 transition-colors duration-200 text-xs">
                        Voltar
                    </button>
                </div>
            </div>
        </div>
    </div>

    <!-- Se tem acesso, renderiza normalmente -->
    <slot v-else />
</template>

<script>
import PlanService from '_root/logic/services/PlanService';

export default {
    name: 'PlanDemoOverlay',
    props: {
        requiredModule: {
            type: String,
            required: true,
        },
        title: {
            type: String,
            default: 'Recurso exclusivo',
        },
        description: {
            type: String,
            default: 'Este recurso nao esta disponivel no seu plano atual. Faca um upgrade para desbloquear todas as funcionalidades.',
        },
    },
    computed: {
        hasAccess() {
            return PlanService.hasModule(this.requiredModule);
        },
        currentPlanName() {
            const plan = PlanService.getPlan();
            return plan?.name || null;
        },
    },
    methods: {
        contactSupport() {
            if (window.$chatwoot && typeof window.$chatwoot.toggle === 'function') {
                window.$chatwoot.toggle('open');
            }
        },
        goBack() {
            this.$router.back();
        },
    },
};
</script>
